import { render, staticRenderFns } from "./ClassCourses.vue?vue&type=template&id=338544e1&scoped=true"
import script from "./ClassCourses.vue?vue&type=script&lang=js"
export * from "./ClassCourses.vue?vue&type=script&lang=js"
import style0 from "./ClassCourses.vue?vue&type=style&index=0&id=338544e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338544e1",
  null
  
)

export default component.exports